import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { Button, SpeechBubble, StateArt } from '../ui/index.js'

/**
 * The catch all screen (QA-024). A mistyped address or a stale deep link is a dead end for a
 * child who cannot read an error, so this screen is Doktor Kunduz, one line, and one primary
 * button back to Yuva. POL-13: the art is the real `misc/*` file, never a tinted box.
 */
export function NotFoundScreen() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className="state">
      <StateArt id="kunduz/point" />
      <SpeechBubble speaker="kunduz">{t('notFound.text')}</SpeechBubble>
      <Button onClick={() => navigate('/yuva', { replace: true })}>{t('notFound.home')}</Button>
    </div>
  )
}
